// extracted by mini-css-extract-plugin
export default {"projectsPage":"projects_projectsPage__s7CUV","header":"projects_header__vc2tn","wrapper":"projects_wrapper__G0MGu","main":"projects_main__IQ3eY","aside":"projects_aside__XhNbQ"};